import React from 'react';
import CategoryCard from './CategoryCard';
import Loader from '../../../../shared/Loader';
import Page from '../../../../shared/Page';

const CategoriesNew = ({ list = {}, loading }) => {
  return (
    <div className="bg-white py-1">
      <div className="max-w-[1400px] mx-auto p-4 font-primary mt-5 lg:mt-10 mb-5">
        <div className="text-center mb-10">
          <h2 className="font-semibold text-2xl md:text-5xl leading-[100%] text-[#1F4B81] inline-block align-middle">
            Paslaugos
          </h2>
          <div className="w-30 h-0.5 bg-[#5180CA] mt-3 mx-auto" />
        </div>

        {loading ? (
          <Page>
            <Loader />
          </Page>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center">
            {Object.entries(list)
              .sort(([, aServices], [, bServices]) => {
                const aId = aServices[0]?.displayCategoryId ?? 0;
                const bId = bServices[0]?.displayCategoryId ?? 0;
                return aId - bId;
              })
              .map(([title, services], index) => (
                <CategoryCard
                  key={title}
                  title={title}
                  services={services}
                  displayCategoryId={services[0]?.displayCategoryId}
                  defaultExpanded={index === 0}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriesNew;
